<template>
    <div id="Container_ePharmacyOptions">
        <b-row>
            <b-col md="12">
                <MdTitle v-bind:Text="$t('ePharmacyOptions.Title')" />  
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
                <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                    <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
                        <div class="tab-pane fade show active" id="contentPharmacy" role="tabpanel">
                            <b-row>
                                <b-col lg="12" md="12" sm="12"> 
                                    <fieldset class="customWells">
                                        <legend>{{ $t('ePharmacyOptions.Pharmacy.AutoValidationLabel') }}</legend>
                                        <b-row>
                                            <b-col md="6" lg="6" sm="12">
                                                <MdCheckBox
                                                    v-bind:Label="this.$t('ePharmacyOptions.Pharmacy.AutoValidateMedicationOrder')"
                                                    v-bind:Name="'checkbox-autoValidateMedicationOrder'"
                                                    v-bind:ClassProp="'AlignCheck'"
                                                    v-bind:CheckedValue="true"
                                                    v-bind:UncheckedValue="false"
                                                    v-model="editableItem.autoValidateMedicationOrder"
                                                    v-on:change="changeAutoValidateMedicationOrder"
                                                />
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col lg="3" md="3" sm="12">
                                                <MdDateTime
                                                    :Label="$t('Shared.StartDate')"
                                                    :Model="autoValidateTimeFrom"
                                                    @input="changeAutoValidateTimeFrom"
                                                    :Id="'input_autoValidateTimeFrom'"
                                                    :Type="'datetime'"
                                                    :isValid="isValidDateAndTimeFrom"
                                                    :invalidMessage="isValidDateAndTimeFromMessage"
                                                    :isConfirm="false"
                                                    :ReadOnly="editableItem.autoValidateMedicationOrder === false">
                                                </MdDateTime>
                                            </b-col>
                                            <b-col lg="3" md="3" sm="12">
                                                <MdDateTime
                                                    :Label="$t('Shared.EndDate')"
                                                    :Model="autoValidateTimeTo"
                                                    @input="changeAutoValidateTimeTo"
                                                    :Id="'input_autoValidateTimeTo'"
                                                    :Type="'datetime'"
                                                    :isValid="isValidDateAndTimeTo"
                                                    :invalidMessage="isValidDateAndTimeToMessage"
                                                    :isConfirm="false"
                                                    :ReadOnly="editableItem.autoValidateMedicationOrder === false">
                                                </MdDateTime>
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col lg="12" md="12" sm="12"> 
                                    <fieldset class="customWells">
                                        <legend>{{ $t('ePharmacyOptions.Pharmacy.MaxDaysLabel') }}</legend>
                                        <b-row>
                                            <b-col lg="3" md="3" sm="12">             
                                                <MdEdit 
                                                    v-bind:Label="$t('ePharmacyOptions.Pharmacy.DaysToProcessDrugTypeA')"
                                                    v-bind:TypeProp="'number'" 
                                                    v-bind:Name="'input-daysToProcessDrugTypeA'"
                                                    v-bind:Min="'0'"
                                                    v-bind:Step="'1'"
                                                    v-model="editableItem.daysToProcessDrugTypeA"
                                                    v-bind:Id="'input_daysToProcessDrugTypeA'">                                     
                                                </MdEdit>
                                            </b-col>
                                            <b-col lg="3" md="3" sm="12">             
                                                <MdEdit 
                                                    v-bind:Label="$t('ePharmacyOptions.Pharmacy.DaysToProcessDrugTypeB')"
                                                    v-bind:TypeProp="'number'" 
                                                    v-bind:Name="'input-daysToProcessDrugTypeB'"
                                                    v-bind:Min="'0'"
                                                    v-bind:Step="'1'"
                                                    v-model="editableItem.daysToProcessDrugTypeB"
                                                    v-bind:Id="'input_daysToProcessDrugTypeB'">                                     
                                                </MdEdit>
                                            </b-col>
                                            <b-col lg="3" md="3" sm="12">             
                                                <MdEdit 
                                                    v-bind:Label="$t('Shared.General')"
                                                    v-bind:TypeProp="'number'" 
                                                    v-bind:Name="'input-daysToProcessDrugTypeGeneral'"
                                                    v-bind:Min="'0'"
                                                    v-bind:Step="'1'"
                                                    v-model="editableItem.daysToProcessDrugTypeGeneral"
                                                    v-bind:Id="'input_daysToProcessDrugTypeGeneral'">                                     
                                                </MdEdit>
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                </b-col>
                            </b-row>
                           <MdTitle v-bind:Text="$t('Shared.General')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>                                                                                    
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Pharmacy.PrintAfterFillOrder')"
                                        v-bind:Name="'checkbox-printAfterFillOrder'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.printAfterFillOrder"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Pharmacy.RestrictPharmItemReloaction')"
                                        v-bind:Name="'checkbox-restrictPharmItemReloaction'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.restrictPharmItemReloaction"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ValidateInternalPrescriptions')"
                                        v-bind:Name="'checkbox-validateInternalPrescriptions'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.validateInternalPrescriptions"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ByPassInventory')"
                                        v-bind:Name="'checkbox-byPassInventory'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.byPassInventory"
                                    />
                                </b-col>                                                                
                            </b-row>
                            <b-row>
                                <b-col lg="3" md="3" sm="12">              
                                    <MdSelect
                                        v-bind:Label="$t('ePharmacyOptions.Pharmacy.DefaultLocation')"
                                        data-field="select-defaultLocation"
                                        v-bind:Options="pharmacyLocationList"
                                        v-bind:FieldDescription="'description'"
                                        v-bind:FieldCode="'code'"
                                        v-bind:Model="defaultLocationModel"                       
                                        v-bind:Multiple="false"
                                        :Input="changeDropDownLocation"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <div class="tab-pane fade" id="contentPrescriptions" role="tabpanel">
                            <b-row>
                                <b-col lg="12" md="12" sm="12">
                                    <fieldset class="customWells">
                                        <legend>{{ $t('ePharmacyOptions.Prescriptions.ShowDrugNameAs') }}</legend>
                                        <b-row>
                                            <b-col lg="3" md="3" sm="12">              
                                                <MdSelect
                                                    data-field="select-showDrugNameAs1"
                                                    v-bind:Options="drugNameOptions"
                                                    v-bind:FieldDescription="'description'"
                                                    v-bind:FieldCode="'code'"
                                                    v-bind:Model="showDrugNameAs1Model"                       
                                                    v-bind:Multiple="false"
                                                    :Input="changeDropDownDrugName1"
                                                />
                                            </b-col>
                                            <b-col lg="3" md="3" sm="12">              
                                                <MdSelect
                                                    data-field="select-showDrugNameAs2"
                                                    v-bind:Options="drugNameOptions"
                                                    v-bind:FieldDescription="'description'"
                                                    v-bind:FieldCode="'code'"
                                                    v-bind:Model="showDrugNameAs2Model"                       
                                                    v-bind:Multiple="false"
                                                    :Input="changeDropDownDrugName2"
                                                />
                                            </b-col>
                                             <b-col lg="3" md="3" sm="12">              
                                                <MdSelect
                                                    data-field="select-showDrugNameAs3"
                                                    v-bind:Options="drugNameOptions"
                                                    v-bind:FieldDescription="'description'"
                                                    v-bind:FieldCode="'code'"
                                                    v-bind:Model="showDrugNameAs3Model"                       
                                                    v-bind:Multiple="false"
                                                    :Input="changeDropDownDrugName3"
                                                />
                                            </b-col>
                                            <b-col lg="3" md="3" sm="12">              
                                                <MdSelect
                                                    data-field="select-showDrugNameAs4"
                                                    v-bind:Options="drugNameOptions"
                                                    v-bind:FieldDescription="'description'"
                                                    v-bind:FieldCode="'code'"
                                                    v-bind:Model="showDrugNameAs4Model"                       
                                                    v-bind:Multiple="false"
                                                    :Input="changeDropDownDrugName4"
                                                />
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="12" md="12" sm="12">
                                    <fieldset class="customWells">
                                        <legend>{{ $t('Shared.Sig') }}</legend>
                                        <b-row>
                                            <b-col md="3" lg="3" sm="12">
                                            <MdCheckBox
                                                v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ExcludeDayFromSig')"
                                                v-bind:Name="'checkbox-excludeDayFromSig'"
                                                v-bind:ClassProp="'AlignCheck'"
                                                v-bind:CheckedValue="true"
                                                v-bind:UncheckedValue="false"
                                                v-model="editableItem.excludeDayFromSig"
                                            />
                                            </b-col>
                                            <b-col md="3" lg="3" sm="12">
                                                <MdCheckBox
                                                    v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.EnforceSigAction')"
                                                    v-bind:Name="'checkbox-enforceSigAction'"
                                                    v-bind:ClassProp="'AlignCheck'"
                                                    v-bind:CheckedValue="true"
                                                    v-bind:UncheckedValue="false"
                                                    v-model="editableItem.enforceSigAction"
                                                />
                                            </b-col>
                                            <b-col md="3" lg="3" sm="12">
                                                <MdCheckBox
                                                    v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.EnforceSigRoute')"
                                                    v-bind:Name="'checkbox-enforceSigRoute'"
                                                    v-bind:ClassProp="'AlignCheck'"
                                                    v-bind:CheckedValue="true"
                                                    v-bind:UncheckedValue="false"
                                                    v-model="editableItem.enforceSigRoute"
                                                />
                                            </b-col>
                                            <b-col md="3" lg="3" sm="12">
                                                <MdCheckBox
                                                    v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.EnforceSigReasonPRN')"
                                                    v-bind:Name="'checkbox-enforceSigReasonPRN'"
                                                    v-bind:ClassProp="'AlignCheck'"
                                                    v-bind:CheckedValue="true"
                                                    v-bind:UncheckedValue="false"
                                                    v-model="editableItem.enforceSigReasonPRN"
                                                />
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                </b-col>
                            </b-row>

                           <MdTitle v-bind:Text="$t('Shared.General')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>                                                                                    
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ByPassPhysicianSignature')"
                                        v-bind:Name="'checkbox-byPassPhysicianSignature'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.byPassPhysicianSignature"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.UsePatientDoctorAsPrescriber')"
                                        v-bind:Name="'checkbox-usePatientDoctorAsPrescriber'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.usePatientDoctorAsPrescriber"
                                    />
                                </b-col>
                               <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ShowPrintOrder')"
                                        v-bind:Name="'checkbox-showPrintOrder'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showPrintOrder"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.PrintAfterSave')"
                                        v-bind:Name="'checkbox-printAfterSave'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.printAfterSave"
                                    />
                                </b-col>                                
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.InactivePrescAtAnyStatus')"
                                        v-bind:Name="'checkbox-inactivePrescAtAnyStatus'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.inactivePrescAtAnyStatus"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.AllowVoidNoFilledOrFullyGiven')"
                                        v-bind:Name="'checkbox-allowVoidNoFilledOrFullyGiven'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.allowVoidNoFilledOrFullyGiven"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.CopyActivePresc')"
                                        v-bind:Name="'checkbox-copyActivePresc'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.copyActivePresc"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.CopyActivePrescEnforceReason')"
                                        v-bind:Name="'checkbox-copyActivePrescEnforceReason'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.copyActivePrescEnforceReason"
                                    />
                                </b-col>                                
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ShowAllMedications')"
                                        v-bind:Name="'checkbox-showAllMedications'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showAllMedications"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.AllowAllergyDrugs')"
                                        v-bind:Name="'checkbox-allowAllergyDrugs'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.allowAllergyDrugs"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('Shared.NoEndDate')"
                                        v-bind:Name="'checkbox-showNoEndDate'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showNoEndDate"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('Shared.NoStartDate')"
                                        v-bind:Name="'checkbox-showNoStartDate'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showNoStartDate"
                                    />
                                </b-col>                                
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.InternalPrescriptionsOnAppt')"
                                        v-bind:Name="'checkbox-internalPrescriptionsOnAppt'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.internalPrescriptionsOnAppt"
                                    />
                                 </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.EnforceDiagnosis')"
                                        v-bind:Name="'checkbox-enforceDiagnosis'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.enforceDiagnosis"
                                    />
                                </b-col>                                 
                            </b-row>
                      
                        </div>
                        <div class="tab-pane fade" id="contentMedicationInbox" role="tabpanel">
                            <MdTitle v-bind:Text="$t('Shared.General')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>                                                                                                                
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MedicationInbox.BypassMedInbox')"
                                        v-bind:Name="'checkbox-bypassMedInbox'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.bypassMedInbox"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MedicationInbox.PrintAfterReceive')"
                                        v-bind:Name="'checkbox-printAfterReceive'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.printAfterReceive"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MedicationInbox.AllowReceivedExpiredPresc')"
                                        v-bind:Name="'checkbox-allowReceivedExpiredPresc'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.allowReceivedExpiredPresc"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <div class="tab-pane fade" id="contentMars" role="tabpanel">
                            <b-row>
                                <b-col lg="12" md="12" sm="12"> 
                                    <fieldset class="customWells">
                                        <legend>{{ $t('ePharmacyOptions.MARS.MedicationAdministrationRules') }}</legend>
                                        <b-row>
                                            <b-col lg="3" md="3" sm="12">
                                                <MdEdit 
                                                    v-bind:Label="$t('ePharmacyOptions.MARS.TimeFrameForAdmInMinutes')"
                                                    v-bind:TypeProp="'number'" 
                                                    v-bind:Name="'date-timeFrameForAdmInMinutes'"
                                                    v-bind:Min="'0'"
                                                    v-bind:Step="'1'"
                                                    v-model="editableItem.timeFrameForAdmInMinutes"
                                                    v-bind:Id="'input_timeFrameForAdmInMinutes'">                                     
                                                </MdEdit>
                                            </b-col>
                                            <b-col md="3" lg="3" sm="12">
                                                <MdEdit 
                                                    v-bind:Label="$t('ePharmacyOptions.MARS.MaxAdmDelayOnMinutes')"
                                                    v-bind:TypeProp="'number'" 
                                                    v-bind:Name="'date-maxAdmDelayOnMinutes'"
                                                    v-bind:Min="'0'"
                                                    v-bind:Step="'1'"
                                                    v-model="editableItem.maxAdmDelayOnMinutes"
                                                    v-bind:Id="'input_maxAdmDelayOnMinutes'">                                     
                                                </MdEdit>
                                            </b-col>
                                        </b-row>
                                    </fieldset>
                                </b-col>
                            </b-row>
                            <MdTitle v-bind:Text="$t('Shared.General')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MARS.ShowAllMissedDoses')"
                                        v-bind:Name="'checkbox-showAllMissedDoses'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showAllMissedDoses"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MARS.UseMarsScanDose')"
                                        v-bind:Name="'checkbox-useMarsScanDose'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.useMarsScanDose"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MARS.ShowPatPictureNursesDB')"
                                        v-bind:Name="'checkbox-showPatPictureNursesDB'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showPatPictureNursesDb"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.MARS.ByPassMarsSignature')"
                                        v-bind:Name="'checkbox-byPassMarsSignature'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.byPassMarsSignature"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Prescriptions.ShowMARSStockInfo')"
                                        v-bind:Name="'checkbox-showMARSStockInfo'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showMARSStockInfo"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                        <div class="tab-pane fade" id="contentNotifications" role="tabpanel">
                            <MdTitle v-bind:Text="$t('ePharmacyOptions.Notifications.NotificationLabel')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Notifications.SendNotification')"
                                        v-bind:Name="'checkbox-sendNotification'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.sendNotification"
                                        v-on:change="changeSendNotification"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit 
                                        v-bind:Label="$t('Shared.TimeFrom')"
                                        v-bind:TypeProp="'time'" 
                                        v-bind:Name="'date-timeFrom'"
                                        v-model="timeFrom"
                                        v-bind:isReadOnly="editableItem.sendNotification === false"
                                        @change="changeTimeFrom"
                                        v-bind:Id="'input_timeFrom'">                                     
                                    </MdEdit>
                                </b-col>
                                <b-col lg="3" md="3" sm="12">
                                    <MdEdit 
                                        v-bind:Label="$t('Shared.TimeTo')"
                                        v-bind:TypeProp="'time'" 
                                        v-bind:Name="'date-timeTo'"
                                        v-model="timeTo"
                                        v-bind:isReadOnly="editableItem.sendNotification === false"
                                        @change="changeTimeTo"
                                        v-bind:Id="'input_timeTo'">                                     
                                    </MdEdit>
                                </b-col>
                            </b-row>
                            <b-row class="mt-3">
                                <b-col lg="12" md="12" sm="12">
                                    <fieldset class="customWells">
                                        <legend>{{ $t('ePharmacyOptions.Notifications.NotificationType') }}</legend>
                                        <MdRadioGroup
                                            v-model="editableItem.notificationType"
                                            v-bind:Options="notificationTypeOptions"
                                            v-bind:Name="'radio-notificationTypeOptions'"
                                            v-bind:Stacked="false"
                                            v-bind:isReadOnly="editableItem.sendNotification === false"
                                        />
                                    </fieldset>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12" md="12" sm="12">   
                                    <fieldset class="customWells">
                                        <legend>{{ $t('Shared.EmployeeType') }}</legend>        
                                        <MdCheckListBox2 
                                            v-model="employeeType"
                                            v-bind:Options="employeeTypeList"
                                            v-bind:columnCount="4"           
                                            :textField="'description'"
                                            :valueField="'code'"
                                            v-bind:OnChangeProp="changeEmployeeType"
                                            v-bind:isReadOnly="editableItem.sendNotification === false"/> 
                                    </fieldset>
                                </b-col>  
                            </b-row>
                        </div>
                        <div class="tab-pane fade" id="contentInterfaces" role="tabpanel">
                            <MdTitle v-bind:Text="$t('ePharmacyOptions.Interfaces.InHealthLabel')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Interfaces.ShowInHealthInterface')"
                                        v-bind:Name="'checkbox-showInHealthInterface'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.showInHealthInterface"
                                    />
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="6" md="6" sm="12">
                                    <MdEdit 
                                        v-bind:Label="$t('ePharmacyOptions.Interfaces.InHealthUrlToken')"
                                        v-bind:TypeProp="'text'" 
                                        v-bind:Name="'text-InHealthUrlToken'"
                                        v-model="editableItem.inHealthUrlToken"
                                        v-bind:Id="'input_InHealthUrlToken'">                                     
                                    </MdEdit>
                                </b-col>
                                <b-col lg="6" md="6" sm="12">
                                    <MdEdit 
                                        v-bind:Label="$t('ePharmacyOptions.Interfaces.InHealthUrl')"
                                        v-bind:TypeProp="'text'" 
                                        v-bind:Name="'text-InHealthUrl'"
                                        v-model="editableItem.inHealthUrl"
                                        v-bind:Id="'input_InHealthUrl'">                                     
                                    </MdEdit>
                                </b-col>
                            </b-row>

                            <MdTitle v-bind:Text="$t('ePharmacyOptions.Interfaces.NewCropLabel')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col lg="12" md="12" sm="12">
                                    <fieldset class="customWells">
                                        <legend>{{ $t('ePharmacyOptions.Interfaces.DrugStatus') }}</legend>
                                        <MdRadioGroup
                                            v-model="editableItem.drugStatus"
                                            v-bind:Options="drugStatusOptions"
                                            v-bind:Name="'radio-drugStatus'"
                                            v-bind:Stacked="false"
                                        />
                                    </fieldset>
                                </b-col>
                            </b-row>

                            <MdTitle v-bind:Text="$t('ePharmacyOptions.Interfaces.EmdeonLabel')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Interfaces.EnableePharImport')"
                                        v-bind:Name="'checkbox-EnableePharImport'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.enableePharImport"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Interfaces.NotifySupportOnePharErrors')"
                                        v-bind:Name="'checkbox-NotifySupportOnePharErrors'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.notifySupportOnePharErrors"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Interfaces.BypassFreq')"
                                        v-bind:Name="'checkbox-bypassFreq'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.bypassFreq"
                                    />
                                </b-col>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Interfaces.ActiveMedOnly')"
                                        v-bind:Name="'checkbox-ActiveMedOnly'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.activeMedOnly"
                                    />
                                </b-col>
                            </b-row>

                            <MdTitle v-bind:Text="$t('ePharmacyOptions.Interfaces.OmnicellLabel')"  v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
                            <b-row>
                                <b-col md="3" lg="3" sm="12">
                                    <MdCheckBox
                                        v-bind:Label="this.$t('ePharmacyOptions.Interfaces.UseOmnicellMARS')"
                                        v-bind:Name="'checkbox-UseOmnicellMARS'"
                                        v-bind:ClassProp="'AlignCheck'"
                                        v-bind:CheckedValue="true"
                                        v-bind:UncheckedValue="false"
                                        v-model="editableItem.useOmnicellMARS"
                                    />
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </MdTabList>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:Name="'btnsave'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-bind:isReadOnly="pendingChanges === false"
                v-on:click="save()"
            />
        </div>
    </div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js';
import EmployeeTypeService from '@/services/employeetypes.service'
import ePharmacyLocationsService from '@/services/epharmacylocation.service';
import PharmacyOptionService from '@/services/pharmacyoption.service';
import Utils from "@/common/utils";
import moment from 'moment'
import { EventBus } from '@/event-bus.js';

export default {
    name: 'ePharmacyOptions',
    mixins: [DBFunctions, ShowMessage],

    data() {
        return {
            OptionsRightMenu:{
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            },
            tablist: [
                { title: this.$t('Shared.Pharmacy'), link: '#contentPharmacy', active: true},
                { title: this.$t('ePharmacyOptions.Tabs.Prescriptions'), link: '#contentPrescriptions'},
                { title: this.$t('Shared.MedicationInbox'), link: '#contentMedicationInbox'},
                { title: this.$t('Shared.MARS'), link: '#contentMars'},
                { title: this.$t('ePharmacyOptions.Tabs.Notifications'), link: '#contentNotifications'},
                { title: this.$t('ePharmacyOptions.Tabs.Interfaces'), link: '#contentInterfaces'}
            ],
            editableItem: {
                excludeDayFromSig: false,
                byPassInventory: false,
                byPassPhysicianSignature: false,
                usePatientDoctorAsPrescriber: false,
                showPrintOrder: false,
                printAfterSave: false,
                inactivePrescAtAnyStatus: false,
                allowVoidNoFilledOrFullyGiven: false,
                copyActivePresc: false,
                copyActivePrescEnforceReason: false,
                showAllMedications: false,
                allowAllergyDrugs: false,
                showNoEndDate: false,
                showNoStartDate: false,
                internalPrescriptionsOnAppt: false,
                showMARSStockInfo: false,
                validateInternalPrescriptions: false,
                allowReceivedExpiredPresc: false,
                enforceSigAction: false,
                enforceSigRoute: false,
                enforceSigReasonPRN: false,
                enforceDiagnosis: false,
                showDrugNameAs1: null,
                showDrugNameAs2: null,
                showDrugNameAs3: null,
                showDrugNameAs4: null,
                printAfterFillOrder: false,
                restrictPharmItemReloaction: false,
                daysToProcessDrugTypeA: null,
                daysToProcessDrugTypeB: null,
                daysToProcessDrugTypeGeneral: null,
                defaultLocation: null,
                autoValidateMedicationOrder: false,
                autoValidateTimeFrom: null,
                autoValidateTimeTo: null,
                bypassMedInbox: false,
                printAfterReceive: false,
                showAllMissedDoses: false,
                useMarsScanDose: false,
                showPatPictureNursesDb: false,
                byPassMarsSignature: false,
                timeFrameForAdmInMinutes: null,
                sendNotification: false,
                timeFrom: null,
                timeTo: null,
                notificationType: null,
                employeeType: null,
                showInHealthInterface: false,
                inHealthUrlToken: null,
                inHealthUrl: null,
                drugStatus: null,
                enableePharImport: false,
                notifySupportOnePharErrors: false,
                bypassFreq: false,
                activeMedOnly: false,
                useOmnicellMARS: false,
                maxAdmDelayOnMinutes: null
            },
            drugNameOptions: [
                { description: this.$t('Shared.DrugName'), code: 'Drug Name' },
                { description: this.$t('ePharmacyOptions.DrugNameAs.ActiveIng'), code: 'Active Ing' },
                { description: this.$t('Shared.Dosage'), code: 'Dosage' },
                { description: this.$t('Shared.Form'), code: 'Form' }
            ],
            pharmacyLocationList: [],
            notificationTypeOptions: [
                { text: this.$t('ePharmacyOptions.NotificationType.Text'), value: 'TEXT' },
                { text: this.$t('Shared.Email'), value: 'EMAIL' },
                { text: this.$t('ePharmacyOptions.NotificationType.Both'), value: 'BOTH' }
            ],
            drugStatusOptions: [
                { text: this.$t('Shared.Ordered'), value: 'Ordered' },
                { text: this.$t('Shared.Pending'), value: 'Pending' },
                { text: this.$t('Shared.Filled'), value: 'Filled' },
                { text: this.$t('Shared.Validated'), value: 'Validated' },
                { text: this.$t('Shared.Received'), value: 'Received' },
            ],
            employeeTypeList: [],
            showDrugNameAs1Model: {
                code: null,
                description: null
            },
            showDrugNameAs2Model: {
                code: null,
                description: null
            },
            showDrugNameAs3Model: {
                code: null,
                description: null
            },
            showDrugNameAs4Model: {
                code: null,
                description: null
            },
            defaultLocationModel: {
                code: null,
                description: null
            },
            timeTo: null,
            timeFrom: null,
            autoValidateTimeFrom: null,
            autoValidateTimeTo: null,
            employeeType: [],
            isValidDateAndTimeTo: true,
            isValidDateAndTimeFrom: true,
            isValidDateAndTimeToMessage: null,
            isValidDateAndTimeFromMessage: null,
            pendingChanges: false
        }
    },

    methods: {
        save() {
            if (this.validate()) {
                if (this.editableItem.daysToProcessDrugTypeA === '') {
                    this.editableItem.daysToProcessDrugTypeA = null;
                }
                if (this.editableItem.daysToProcessDrugTypeB === '') {
                    this.editableItem.daysToProcessDrugTypeB = null;
                }
                if (this.editableItem.daysToProcessDrugTypeGeneral === '') {
                    this.editableItem.daysToProcessDrugTypeGeneral = null;
                }
                if (this.editableItem.timeFrameForAdmInMinutes === '') {
                    this.editableItem.timeFrameForAdmInMinutes = null;
                }
                if (this.editableItem.maxAdmDelayOnMinutes === '') {
                    this.editableItem.maxAdmDelayOnMinutes = null;
                }

                if (this.editableItem.recId) {
                    PharmacyOptionService
                        .update(this.editableItem.recId, this.editableItem)
                        .then((response) => {
                            if(response.status == '200'){
                                this.pendingChanges = false;
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'), 
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.getPharmacyOptions();
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                } else {
                    PharmacyOptionService
                        .add(this.editableItem)
                        .then((response) => {
                            if(response.status == '200'){
                                this.pendingChanges = false;
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'), 
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.getPharmacyOptions();
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                }
            }
        },

        changeDropDownDrugName1(value) {
            this.editableItem.showDrugNameAs1 = value ? value.code : null;
        },

        changeDropDownDrugName2(value) {
            this.editableItem.showDrugNameAs2 = value ? value.code : null;
        },

        changeDropDownDrugName3(value) {
            this.editableItem.showDrugNameAs3 = value ? value.code : null;
        },

        changeDropDownDrugName4(value) {
            this.editableItem.showDrugNameAs4 = value ? value.code : null;
        },

        changeDropDownLocation(value) {
            this.editableItem.defaultLocation = value ? value.code : null;
        },

        changeSendNotification(value) {
            if (value === false) {
                this.editableItem.timeFrom = null;
                this.editableItem.timeTo = null;
                this.editableItem.notificationType = null;
                this.editableItem.employeeType = '';
                this.timeFrom = null;
                this.timeTo = null;
                this.employeeType = [];
            }
        },

        changeAutoValidateMedicationOrder(value) {
            if (value === false) {
                this.editableItem.autoValidateTimeFrom = null;
                this.editableItem.autoValidateTimeTo = null;
                this.autoValidateTimeFrom = null;
                this.autoValidateTimeTo = null;
            }
        },

        changeTimeTo(value) {
            if (value && Utils.isValidTime(value)) {
                this.editableItem.timeTo = Utils.formatterShortTimeToIso(value);
            } else {
                this.editableItem.timeTo = null;
                this.timeTo = null;
            }
        },

        changeTimeFrom(value) {
            if (value && Utils.isValidTime(value)) {
                this.editableItem.timeFrom = Utils.formatterShortTimeToIso(value);
            } else {
                this.editableItem.timeFrom = null;
                this.timeFrom = null;
            }
        },

        changeEmployeeType(value) {
            if (value) {
                this.editableItem.employeeType = value.join(',');
            } else {
                this.employeeType = [];
                this.editableItem.employeeType = null;
            }
        },

        changeAutoValidateTimeFrom(value) {
            this.isValidDateAndTimeFrom = true;
            this.isValidDateAndTimeFromMessage = null;
            this.autoValidateTimeFrom = value;
            this.editableItem.autoValidateTimeFrom = value;
        },

        changeAutoValidateTimeTo(value) {
            this.isValidDateAndTimeTo = true;
            this.isValidDateAndTimeToMessage = null;
            this.autoValidateTimeTo = value;
            this.editableItem.autoValidateTimeTo = value;
        },

        validate() {
            let isValidNotificationTime = true;
            if (this.editableItem.autoValidateMedicationOrder === true) {
                const isoDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss';
                this.isValidDateAndTimeTo = Utils.isValidDate(this.autoValidateTimeTo, isoDateTimeFormat, true);
                this.isValidDateAndTimeFrom = Utils.isValidDate(this.autoValidateTimeFrom, isoDateTimeFormat, true);
                if (this.isValidDateAndTimeFrom === false) {
                    this.isValidDateAndTimeFromMessage= this.$t("Shared.InvalidDate");
                    this.showMessage(this.$tc('Msg.Error'),this.$t('ePharmacyOptions.InvalidAutoDateFrom'),"errorAutoHide");
                }

                if (this.isValidDateAndTimeTo === false) {
                    this.isValidDateAndTimeToMessage= this.$t("Shared.InvalidDate");
                    this.showMessage(this.$tc('Msg.Error'),this.$t('ePharmacyOptions.InvalidAutoDateTo'),"errorAutoHide");
                }

                if (
                    this.isValidDateAndTimeTo === true
                    && this.isValidDateAndTimeFrom === true
                    && moment(this.autoValidateTimeFrom, isoDateTimeFormat) > moment(this.autoValidateTimeTo, isoDateTimeFormat)
                ) {
                    isValidNotificationTime = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('ePharmacyOptions.InvalidAutoDateRange'),"errorAutoHide");
                }
            }
            
            if (this.editableItem.sendNotification === true) {
                if (Utils.isValidTime(this.timeFrom) === false) {
                    isValidNotificationTime = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('ePharmacyOptions.InvalidTimeFrom'),"errorAutoHide");
                } else if (Utils.isValidTime(this.timeTo) === false) {
                    isValidNotificationTime = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('ePharmacyOptions.InvalidTimeTo'),"errorAutoHide");
                } else if (Utils.isValidTime(this.editableItem.employeeType.length) === 0) {
                    isValidNotificationTime = false;
                    this.showMessage(this.$tc('Msg.Error'),this.$t('ePharmacyOptions.InvalidEmployeeType'),"errorAutoHide");
                }
            }

            return this.isValidDateAndTimeTo && this.isValidDateAndTimeFrom && isValidNotificationTime;
        },

        getEmployeeTypes() {
            const param = {
                Active: true
            }
            this.employeeTypeList = [];
            return EmployeeTypeService.getAllEmployeeType(param)
                .then(response => {
                    if (response.status == "200" && response.data) {
                        const data = response.data;
                        data.forEach(element => {
                            this.employeeTypeList.push({
                                code: element.code.trim(),
                                description: element.description
                            })
                        });
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getPharmacyLocations() {
            const parameter ={
                PageSize: 0,
                PageNumber: 0,
                FilterByEmployee: true,
                BuildingRestriction: this.$store.state.restrictions.buildingLocation,
                PharmacyRestriction: this.$store.state.restrictions.pharmacy
            }

            this.pharmacyLocationList = [];
            return ePharmacyLocationsService.getAll(parameter)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        const data = response.data;
                        data.forEach(element => {
                            this.pharmacyLocationList.push({
                                code: element.code.trim(),
                                description: element.name
                            })
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        getPharmacyOptions() {
            PharmacyOptionService.getPharmacyOptions()
                .then((response) => {
                    if(response.status == '200' && response.data){
                        if (Array.isArray(response.data) && response.data.length >= 1) {
                            this.editableItem = response.data[0];

                            let data = this.drugNameOptions.find(element => element.code == this.editableItem.showDrugNameAs1);
                            if (data) {
                                this.$set(this.showDrugNameAs1Model, 'code', data.code);
                                this.$set(this.showDrugNameAs1Model, 'description', data.description);
                            } else {
                                this.$set(this.showDrugNameAs1Model, 'code', null);
                                this.$set(this.showDrugNameAs1Model, 'description', null);
                            }
                            
                            data = this.drugNameOptions.find(element => element.code == this.editableItem.showDrugNameAs2);
                            if (data) {
                                this.$set(this.showDrugNameAs2Model, 'code', data.code);
                                this.$set(this.showDrugNameAs2Model, 'description', data.description);
                            } else {
                                this.$set(this.showDrugNameAs2Model, 'code', null);
                                this.$set(this.showDrugNameAs2Model, 'description', null);
                            }

                            data = this.drugNameOptions.find(element => element.code == this.editableItem.showDrugNameAs3);
                            if (data) {
                                this.$set(this.showDrugNameAs3Model, 'code', data.code);
                                this.$set(this.showDrugNameAs3Model, 'description', data.description);
                            } else {
                                this.$set(this.showDrugNameAs3Model, 'code', null);
                                this.$set(this.showDrugNameAs3Model, 'description', null);
                            }

                            data = this.drugNameOptions.find(element => element.code == this.editableItem.showDrugNameAs4);
                            if (data) {
                                this.$set(this.showDrugNameAs4Model, 'code', data.code);
                                this.$set(this.showDrugNameAs4Model, 'description', data.description);
                            } else {
                                this.$set(this.showDrugNameAs4Model, 'code', null);
                                this.$set(this.showDrugNameAs4Model, 'description', null);
                            }

                            if (Utils.isNullOrEmptyString(this.editableItem.employeeType)) {
                                this.employeeType = [];
                            } else {
                                this.employeeType = this.editableItem.employeeType.split(',');
                            }

                            if (Utils.isNullOrEmptyString(this.editableItem.timeFrom)) {
                                this.timeFrom = null;
                            } else {
                                this.timeFrom = Utils.formatterTimeToString(this.editableItem.timeFrom);
                            }

                            if (Utils.isNullOrEmptyString(this.editableItem.timeTo)) {
                                this.timeTo = null;
                            } else {
                                this.timeTo = Utils.formatterTimeToString(this.editableItem.timeTo);
                            }

                            if (Utils.isNullOrEmptyString(this.editableItem.autoValidateTimeFrom)) {
                                this.autoValidateTimeFrom = null;
                            } else {
                                this.autoValidateTimeFrom = this.editableItem.autoValidateTimeFrom;
                            }

                            if (Utils.isNullOrEmptyString(this.editableItem.autoValidateTimeTo)) {
                                this.autoValidateTimeTo = null;
                            } else {
                                this.autoValidateTimeTo = this.editableItem.autoValidateTimeTo;
                            }

                            data = this.pharmacyLocationList.find(element => element.code == this.editableItem.defaultLocation);
                            if (data) {
                                this.$set(this.defaultLocationModel, 'code', data.code);
                                this.$set(this.defaultLocationModel, 'description', data.description);
                            } else {
                                this.$set(this.defaultLocationModel, 'code', null);
                                this.$set(this.defaultLocationModel, 'description', null);
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        },

        loadInitialData() {
            Promise
                .all([this.getEmployeeTypes(), this.getPharmacyLocations()])
                .then(() => {
                    this.getPharmacyOptions();
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    mounted() {
        this.loadInitialData();

        //this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        EventBus.$on("onChanged", function (e) { 
            this.pendingChanges = e.Changed;
        }.bind(this));
    },

    beforeDestroy () {
        EventBus.$off('onChanged');
    },

    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$tc('Shared.Patient'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(value => {
                if(!value){
                    this.checkExistFavorite('/app/patients');  
                    next();
                } else {
                    this.Save();
                    next();
                }
            })		
        } else {
            next()
        }
    },
}
</script>